import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ProjectReducer(state = initialState.projectContent, action: any) {
  switch (action.type) {
    case types.SAVE_PROJECTCONTENT_SUCCESS:
      return action.projectContent;
    default:
      return state;
  }
}
